module.exports = __webpack_public_path__ + "img/onfocus.5ece7e0f.png";